import axios from '@/api/axios'

const getGroupsAthletes = groupId => {
  return axios.get(`/groupsAthletes?groupId=${groupId}`)
}

const addGroupsAthlete = athlete => {
  return axios.post(`/groupsAthletes`, athlete)
}

const deleteGroupsAthlete = id => {
  return axios.delete(`/groupsAthletes/${id}`)
}

export default {
  getGroupsAthletes,
  addGroupsAthlete,
  deleteGroupsAthlete
}
